import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {QuicklinkStrategy} from 'ngx-quicklink';
import { AuthGuard } from './auth.guard';
import { MainRouteResolver } from './resolvers/main-route.resolver';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

const routes: Routes = [
   { path: '', redirectTo: 'login', pathMatch: 'full' },
   { path: '404', loadComponent: () => import('./page-not-found/page-not-found.component').then(m => m.PageNotFoundComponent) },
  {
    path: 'login',
    loadChildren: () => import('./views/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'others',
    loadChildren: () => import('./views/others/others.module').then(m => m.OthersModule)
  },
  {
    path: 'poc',
    loadChildren: () => import('./views/poc/poc.module').then(m => m.PocModule)
  },
  {
    path: 'public',
    loadChildren: () => import('./views/public/public.module').then(m => m.PublicModule)
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    resolve:{initData:MainRouteResolver},
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: {title: 'Dashboard'}
      },
      {
        path: 'system_management',
        loadChildren: () => import('./views/system-management/system-management.module').then(m => m.SystemManagementModule),
        data:{title:'System Management'}
      },
      {
        path: 'appointments',
        loadChildren: () => import('./views/appointments/appointments.module').then(m => m.AppointmentsModule),
        data:{title:'Appointments'}
      },
      {
        path: 'reporting',
        loadChildren: () => import('./views/reporting/reporting.module').then(m => m.ReportingModule),
        data:{title:'Reporting'}
      },
      {
        path: 'patient',
        loadChildren: () => import('./views/patient/patient.module').then(m => m.PatientModule)
      },
      {
        path: 'todo',
        loadChildren: () => import('./views/todo/todo.module').then(m => m.TodoModule),
        data: {title: 'Todo'}
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'others/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{preloadingStrategy: QuicklinkStrategy})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
